(function(){
  var C = window.ETAPA_COVERS || {};
  function seed(id){ var s = 7; for (var i=0;i<id.length;i++){ s = (s*31 + id.charCodeAt(i))>>>0; } return s; }
  function drawRoute(cv, colors, id, n, band){
    var r = cv.getBoundingClientRect(); if(!r.width) return;
    var dpr = Math.min(2, window.devicePixelRatio||1);
    cv.width = r.width*dpr; cv.height = r.height*dpr;
    var x = cv.getContext("2d"); x.scale(dpr,dpr);
    var g = x.createLinearGradient(0,0,r.width,r.height); g.addColorStop(0,colors[0]); g.addColorStop(1,colors[1]);
    x.fillStyle = g; x.fillRect(0,0,r.width,r.height);
    var s = seed(id); function rnd(){ s = (s*1664525+1013904223)>>>0; return s/4294967296; }
    var pts = []; n = Math.max(2,n);
    for (var i=0;i<n;i++) pts.push([r.width*(.12+.76*i/(n-1)), r.height*(band[0]+band[1]*rnd())]);
    x.strokeStyle="rgba(255,253,249,.55)"; x.lineWidth=1.5; x.setLineDash([2,6]); x.lineCap="round"; x.beginPath();
    pts.forEach(function(p,i){ if(i) x.quadraticCurveTo((pts[i-1][0]+p[0])/2, Math.min(pts[i-1][1],p[1])-20, p[0], p[1]); else x.moveTo(p[0],p[1]); });
    x.stroke(); x.setLineDash([]);
    pts.forEach(function(p,i){ x.fillStyle = i===0 ? colors[2] : "rgba(255,253,249,.95)"; x.beginPath(); x.arc(p[0],p[1], i===0?5.5:4, 0, Math.PI*2); x.fill(); });
    x.strokeStyle="rgba(255,253,249,.08)"; x.lineWidth=1;
    for (var y=r.height*.62;y<r.height;y+=10){ x.beginPath(); x.moveTo(0,y); x.lineTo(r.width,y); x.stroke(); }
  }
  function drawAll(){
    document.querySelectorAll("canvas[data-cover]").forEach(function(cv){
      var d = C[cv.getAttribute("data-cover")]; if(!d) return;
      drawRoute(cv, d.colors, d.id, d.route.length, [.12,.22]);
    });
    var h = document.querySelector("canvas[data-hero]");
    if (h) drawRoute(h, ["#1B1E25","#0F1115","#E4572E"], "etapa-world", 7, [.1,.3]);
    document.querySelectorAll("[data-swatch]").forEach(function(el){
      var d = C[el.getAttribute("data-swatch")]; if(d) el.style.background = "linear-gradient(135deg,"+d.colors[0]+","+d.colors[1]+")";
    });
  }
  // Destination search on the homepage
  var q = document.getElementById("e-search");
  if (q) {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-name]"));
    var nores = document.getElementById("e-nores"), wish = document.getElementById("e-wish");
    function norm(s){ return (s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,""); }
    function filter(){
      var v = norm(q.value.trim()), hits = 0;
      cards.forEach(function(c){ var ok = !v || norm(c.getAttribute("data-name")).indexOf(v) > -1; c.classList.toggle("hidden", !ok); if(ok) hits++; });
      nores.classList.toggle("on", !!v && hits === 0);
      if (wish) wish.value = "liste-attente," + (v ? "souhait-" + v.replace(/[^a-z0-9]+/g,"-") : "");
    }
    q.addEventListener("input", filter);
    document.querySelectorAll("[data-chip]").forEach(function(b){ b.addEventListener("click", function(){ q.value = b.getAttribute("data-chip"); filter(); document.getElementById("destinations").scrollIntoView({behavior:"smooth"}); }); });
  }
  // Sticky buy bar on product pages
  var bar = document.getElementById("e-buybar"), main = document.getElementById("e-buy-main");
  if (bar && main && "IntersectionObserver" in window) {
    new IntersectionObserver(function(es){ bar.classList.toggle("on", !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(main);
  }
  drawAll();
  var t; window.addEventListener("resize", function(){ clearTimeout(t); t = setTimeout(drawAll, 150); });
})();